const carMonitor = {
  systemsummary: {
    navigation: {
      sitemap: "网站地图"
    }
  },
  monitorinfo: {
    carStatus: {
      offonlinetimegreaterthan: "不在线时长大于(天)",
      useageofvehicle: "车辆性质",
      online: "在线",
      offline: "离线",
      commercialvehicle: "商品车",
      testvehicle: "试验车",
      comparisonvehicle: "对标车",
      unlocated: "未定位",
      located: "已定位",
      stopped: "停止",
      moving: "行驶",
      signaledcan: "有CAN",
      nonsignaledcan: "无CAN",
      days: "天",
      hours: "小时",
      minutes: "分",
      seconds: "秒",
      datasubmissiontime: "数据上报时间",
      lastonlinetime: "最后在线时间",
      GPSpositioning: "GPS是否定位",
      whethermoving: "车辆是否行驶",
      whetherhavecansignal: "是否有CAN",
      whetherterminalisonline: "是否在线",
      voltage:"电池电压",
      coolantTemporature:"发动机泠却液温度",
      offonlinetime: "不在线时长",
      vehiclecurrentposition: "车辆当前位置",
      failedtogetwebsocketaddress: "获取websocket地址失败",
      realTimeDialog: {
        carRealData: "车辆实时参数",
        carRealBattery: "当前电池电量(SOC)",
        lastdatasubmissiontime: "最后数据上报时间",
        vehicleTypeCode: "车型编码",
        internalCode: "批次",
        productmodel: "产品型号",
        usearea: "使用区域",
        signalstrength: "信号强度",
        GPSmileage: "GPS里程",
        CANData: "CAN数据",
        Speed: "车速",
        No: "否",
        Yes: "是",
        gpsTime: "GPS时间",
        carLatPos: "车辆关闭前最后报告的位置",
        carRun: "车辆运行数据",
        isOnLine: "是否在线"
      },
      area: "地区",
      model: "车型",
      search: {
        width1: "80",
        width2: "80",
        width3: "60",
        width4: "60"
      }
    }
  },
  plateNumber: "车牌号码",
  OBDwidth: "80px",
  logo: "品牌",
  carModel: "车型",
  series: "系列",
  tips: "请输入",
  vehicleConfiguration: "车系",
  conditionMonitoring: "状态监控",
  vehicle: {
    realtimeData: "车辆实时参数",
    width1: "110px",
    searchWidth: "90px",
    SOC: "当前电池电量",
    yesonline: "在线",
    noonline: "不在线",
    yes: "是",
    no: "否",
    yesdriving: "行驶",
    nodriving: "停止",
    yesCan: "有CAN",
    noCan: "无CAN",
    isonline: "终端是否在线",
    lastActiveTime: "定位时间",
    areaName: "使用区域",
    gpsPosition: "是否定位",
    isdriving: "是否行使",
    gpsMileage: "GPS里程",
    gpsSpeed: "GPS车速",
    canHasData: "CAN数据",
    realtimeError: "暂无数据",
    speedCard: "车速",
    lastParames: "车辆下线前最后一次上报的数据"
  },
  electric: {
    electricManage: {
      alarmrulesname: "报警名称",
      rulestype: "规则类型",
      creattime: "创建时间",
      starttime: "开始时间",
      endtime: "结束时间",
      placeholder: "占位符",
      administrativeAreas: "行政区域",
      polygon: "多边形",
      circular: "圆形",
      outOf: "驶出",
      alarmType: "报警类型",
      speedThreshold: "车速阈值",
      alarmVehicle: "报警车辆",
      description: "描述",
      createdby: "创建人员",
      createdon: "创建时间",
      deleteAlert: "请选中需要删除项",
      alert1: "是否删除",
      prompt: "提示",
      confirm: "确定",
      cancel: "取消",
      successfullyDelete: "删除成功",
      setCarAlert: "请选择电子围栏规则",
      detailCarDialog: {
        vehicledetail: "车辆明细",
        licensePlate: "车牌号码",
        typename: "车型",
        batchcode: "批次"
      },
      wlxq: "电子围栏详情",
      wlss: "围栏所属",
      wlxx: "围栏信息",
      carTitle: "车辆",
      radius: "半径",
      createdByYou: "由我创建",
      readOnly: "否",
      editable: "是",
      readOnlyTip: "您无权操作此项",
      addVehicleTip: "您将为自己的电子围栏新增车辆",
      subCompany: "经销商",
      department: "门店",
      subUserTip: "您可以创建一个电子围栏给您的"
    },
    electricNotes: {
      licensePlate: "车牌号码",
      alarmType: "报警类型",
      alarmTime: "报警时间",
      starttime: "报警时间",
      endtime: "报警结束时间",
      alarmrulesname: "报警名称",
      address: "报警地址",
      whetherended: "是否结束",
      alarmMessage: "围栏信息",
      fenceMessage: "围栏信息",
      alarmCar: "报警信息",
      outOf: "驶出",
      overspeed: "超速",
      unfinished: "未结束",
      finished: "已结束",
      alarmsubtype: "报警子类型",
      currentalarmspeed: "当前报警车速",
      userName: "APP用户",
      ruleName: "围栏名称",
      ruleType: "规则类型",
      status: "状态",
      ending: "已结束",
      noending: "未结束",
      width1: "70px",
      width2: "70px",
      width3: "75px",
      alarmDetail: "电子围栏报警详情"
    }
  },
  terminalCommand: {
    commandName: "命令包名称",
    startTime: "开始时间",
    endTime: "结束时间",
    paramscount: "命令数量",
    loginname: "创建人",
    createdon: "创建时间",
    commondStatus: "命令包状态",
    remark: "备注",
    function: "操作",
    see: "查看",
    notperformed: "未执行",
    Finishedperformed: "执行完毕",
    Inprogress: "执行中",
    add: "添加",
    data: "参数",
    okBtn: "确定",
    cancleBtn: "取消",
    doubleClick: "双击进行操作",
    upload: "上传",
    setData: "设置参数",
    packetnameTips: "请输入命令包名称",
    addFuncTips: "请添加操作",
    addSuccess: "添加成功",
    browse: "浏览",
    yes: "是",
    file: "文件",
    explanation: "说明",
    checkFile: "请选择文件",
    versionnumber: "版本号",
    uploadUrl: "上传路径",
    isSet: "是否设置默认",
    dbcTips: "请填写DBC存放路径",
    regexText: "请填写pkg存放路径",
    such: "如",
    bitian: "该项为必填项",
    gxbun: "该项不能为",
    success: "成功",
    uploadSuccess: "文件上传成功",
    uploadFileTips: "请选择上传文件",
    uploadFilereset: "该文件已上传请重新选择上传文件",
    uploadLoading: "文件上传中",
    formate: "请按正确格式填写",
    width1: "60px",
    width2: "100px",
    width3: "60px",
    width4: "100px",
    width: "100px",
    searchWidth: {
      width1: "90px",
      width2: "80px"
    }
  },
  terminalBatch: {
    commandWdith: "120px",
    taskName: "任务名称",
    commandName: "命令包名称",
    vin: "VIN码",
    loginname: "创建人",
    createtime: "创建时间",
    paramscount: "命令总数",
    yichexiao: "已撤销",
    notperformed: "未执行",
    Inprogress: "执行中",
    Finishedperformed: "完成",
    failedcount: "执行失败",
    tingzx: "暂停执行",
    weizhi: "未知",
    see: "查看任务详情",
    seeBatch: "查看命令包",
    function: "操作",
    add: "新增离线命令任务",
    selectCar: "选择车辆",
    selectObd: "选择OBD设备",
    import: "导入",
    reset: "重置",
    carMessage: "车辆信息",
    okCheck: "已选择",
    numberCar: "辆车",
    notCar: "当前未选择任何车辆",
    remark: "备注",
    okBtn: "确定",
    cancleBtn: "取消",
    tasknameTips: "请输入任务名称",
    selectCarTips: "请选择OBD设备号",
    packetnameTips: "请输入命令包名称",
    addSuccess: "新增完成",
    seeParames: "查看命令包参数",
    data: "参数",
    obdTaskDetail: "OBD升级任务详情",
    taskDetail: "任务命令详细表",
    cartypeid: "车型名称",
    carbatchid: "项目代号",
    terminalcode: "任务OBD",
    online: "在线",
    notOnline: "不在线",
    export: "导出",
    allStatus: "整体完成情况",
    ml: "命令",
    mlParames: "命令参数",
    wancheng: "完成情况",
    selectName: "选择命令名称",
    width3: "60px",
    width4: "100px",
    searchWidth: {
      width1: "90px",
      width2: "80px",
      width3: "105px"
    },
    upgrade: "升级包",
    createUpgrade: "创建升级包",
    HistoricalUpgrade: "历史升级包",
    uploadFiles: "上传文件",
    version: "版本号",
    versionDescription: "版本说明",
    historicalVersion: "历史版本",
    addObdTask: "添加OBD升级任务",
    error: {
      message1: "请输入版本号",
      message2: "请选择上传文件",
      message3: "请选择历史版本",
      message4: "请上传.bin文件",
      message5:'请选择升级类型'
    },
    sjtype:'升级类型',
    sjtype1:'OBD在线升级',
    sjtype2:'车辆在线升级'
  },
  terminalControl: {
    title: "远程调试",
    fileManagement: "终端文件管理",
    loadDir: "加载终端目录",
    downloadFiles: "下载文件",
    shellCommandTitle: "shell命令",
    shellCommand: "命令参数",
    implement: "执行",
    res: "执行结果",
    downloadingData: "正在下载数据...",
    systemPrompt: "系统提示"
  },
  trip: {
    starttime: "开始时间",
    searchWidth: {
      width1: "75px"
    },
    startLngLat: "开始经纬度",
    endttime: "结束时间",
    endLngLat: "结束经纬度",
    accelerate: "急加速次数",
    slowdown: "急减速次数",
    sharpturnCunt: "急转弯次数"
  }
}
export default carMonitor